$(document).ready(function() {
    if($('.section-slider .owl-carousel').html() != undefined) {
        // $('.section-slider .owl-carousel').owlCarousel({
        //     items: 1,
        //     margin: 0,
        //     loop: true,
        //     autoplay: true,
        //     autoplayTimeout: 3500,
        //     autoplayHoverPause: false,
        //     animateOut: 'fadeOut go',
        //     animateIn: 'fadeIn go',
        // });
    }
});